module.exports = ".lui-notification-container{-ms-flex-align:center;align-items:center;-webkit-backdrop-filter:blur(0);backdrop-filter:blur(0);background:transparent;display:-ms-flexbox;display:flex;height:100vh;-ms-flex-pack:center;justify-content:center;left:0;position:fixed;top:0;transition:var(--lui-transitions-default);width:100vw;z-index:1001}.lui-notification-container-open{-webkit-backdrop-filter:blur(5px);backdrop-filter:blur(5px);background:rgba(0,0,0,.3)}"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-notification/theme/lui-notification.global.scss
// module id = 265
// module chunks = 0 1 5